import { api } from "./api";

function b64ToBytes(v: string) {
  const pad = "=".repeat((4 - (v.length % 4)) % 4);
  const raw = atob((v + pad).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

export const pushSupported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
export const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || (navigator as any).standalone === true;
export const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent);

export async function registerSW() {
  if ("serviceWorker" in navigator) return navigator.serviceWorker.register("/sw.js", { scope: "/" });
  return null;
}

export async function currentSubscription() {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.ready;
  return reg.pushManager.getSubscription();
}

export async function enablePush(base = "/me") {
  if (!pushSupported()) throw new Error(isIOS() && !isStandalone() ? "Di iPhone, tambahkan aplikasi ke Layar Utama (Share → Add to Home Screen) lalu buka dari ikon tersebut untuk mengaktifkan notifikasi." : "Browser ini belum mendukung notifikasi push.");
  if (Notification.permission === "denied") throw new Error("Notifikasi diblokir di pengaturan browser/HP. Izinkan dahulu lalu coba lagi.");
  const reg = (await registerSW())!;
  await navigator.serviceWorker.ready;
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Izin notifikasi tidak diberikan.");
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    const { data } = await api.get("/push/public-key");
    sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64ToBytes(data.publicKey) });
  }
  await api.post(`${base}/push-subscribe`, sub.toJSON());
  return sub;
}

export async function disablePush() {
  const sub = await currentSubscription();
  if (!sub) return;
  await api.delete("/me/push-subscribe", { data: sub.toJSON() }).catch(() => {});
  await sub.unsubscribe();
}
